import { useStore } from 'vuex'
import { ref, computed, onMounted } from 'vue'

export default {
    name: "SourceReferences",
    props: {
        sourceId: {
            type: Number,
            required: true
        }
    },
    setup(props) {
        const store = useStore()

        const pageSize = 5

        const isLoading = ref(false)
        const totalHits = computed(() => store.state.main.source_references_total)
        const references = computed(() =>  store.state.main.source_references)

        const fetchReferences = () => {

            if (isLoading.value)
                return

            isLoading.value = true
            
            store.dispatch('main/getSourceReferences', {
                sourceId: props.sourceId,
                skip: references.value.length,
                take: pageSize
            })
            .finally(() => {
                isLoading.value = false
            })
        }

        const showLoadMore = computed(() => totalHits.value > references.value.length)

        onMounted(() => {
            store.state.main.source_references = []
            store.state.main.source_references_total = null
            fetchReferences()
        })

        const getLabel = (labelKey) => store.getters['labels/getLabel']({
            labelCollection: 'SourceReferences',
            labelKey
        })

        const showingLabel = computed(() => getLabel('showing')?.replace('{antal}', references.value.length).replace('{total}', totalHits.value))

        return {
            references,
            totalHits,
            fetchReferences,
            showLoadMore,
            isLoading,
            getLabel,
            showingLabel
        }
    }
}